module.exports = {
          srcSet: __webpack_public_path__ + "f795a7c10836d2825565f1b037fef3bd-64.png"+" 64w",
          images:[ {path: __webpack_public_path__ + "f795a7c10836d2825565f1b037fef3bd-64.png",width: 64,height: 64}],
          src: __webpack_public_path__ + "f795a7c10836d2825565f1b037fef3bd-64.png",
          toString:function(){return __webpack_public_path__ + "f795a7c10836d2825565f1b037fef3bd-64.png"},
          
          width: 64,
          height: 64
        }